import { render, staticRenderFns } from "./SingleTokenMenuFragment.vue?vue&type=template&id=12497a62&"
import script from "./SingleTokenMenuFragment.vue?vue&type=script&lang=js&"
export * from "./SingleTokenMenuFragment.vue?vue&type=script&lang=js&"
import style0 from "./SingleTokenMenuFragment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports